<div class="p-2">
  @if (templateLoading$ | async) {
    <soft-loading-spinner />
  }
  @if ((templateLoading$ | async) === false) {
    <form [formGroup]="form">
      <div class="flex flex-col mt-3">
        <span class="soft-label top">
          {{ '#TIMESTAMP.RECORD.EMPLOYEE' | translate }}
        </span>
        @if (canModifyEmployee()) {
          <soft-entity-input formControlName="employee">
            <ng-template let-entity="entity">
              @if (entity) {
                <span>
                  <strong>{{ entity.number }}</strong>
                  - {{ entity.firstName }}
                </span>
              }
            </ng-template>
            <soft-entity-picker #picker>
              <ng-template
                [softDataView]="'data'"
                [softQueryView]="'query'"
                [title]="'Abfrage'"
                #dataView="dataView"
              >
                <div class="flex flex-col">
                  <soft-master-detail [data]="(employees$ | async) ?? []" #masterDetail>
                    <ng-template let-entity="entity" softMasterTemplate>
                      <div class="entity">
                        <div class="entity-content">
                          <strong>{{ entity.number }}</strong>
                          <span class="desc">
                            {{ entity.firstName }} - {{ entity.lastName }}
                          </span>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template let-entity="entity" softDetailTemplate>
                      <div class="full-width">
                        <div class="detail-row">
                          <h5 class="font-bold">Nummer:</h5>
                          <p>{{ entity.number }}</p>
                        </div>
                        <div class="detail-row">
                          <h5 class="font-bold">Vorname:</h5>
                          <p>{{ entity.firstName }}</p>
                        </div>
                        <div class="detail-row">
                          <h5 class="font-bold">Nachname:</h5>
                          <p>{{ entity.lastName }}</p>
                        </div>
                      </div>
                    </ng-template>
                  </soft-master-detail>
                  <soft-ds-button (click)="dataView.submit(masterDetail)">
                    Auswählen
                  </soft-ds-button>
                </div>
              </ng-template>
            </soft-entity-picker>
          </soft-entity-input>
        }
        @if ((canModifyEmployee()) === false) {
          <soft-input
            [readonly]="true"
            [value]="
              form.value.employee
                ? form.value.employee.number + ' - ' + form.value.employee.lastName
                : ''
            "
          />
        }
      </div>
      <div class="flex flex-row items-start gap-3 flex-nowrap-m">
        <div class="flex flex-col w-full mt-3">
          <label class="soft-label top">
            {{ '#TIMESTAMP.RECORD.TYPE' | translate }}
          </label>
          @if (canModifyTime()) {
            <soft-ds-radio-group
              class="flex h-9 flex-row items-center gap-6"
              (valueChange)="onFlagChange()"
              formControlName="flag"
              data-testid="timestamp-flag"
            >
              <soft-ds-radio-option value="arrival">
                {{ '#TIMESTAMP.TYPE.ARRIVAL' | translate }}
              </soft-ds-radio-option>
              <soft-ds-radio-option value="departure">
                {{ '#TIMESTAMP.TYPE.DEPARTURE' | translate }}
              </soft-ds-radio-option>
            </soft-ds-radio-group>
          } @else {
            <soft-ds-badge class="w-fit" variant="info" size="lg">
              @if (flag() === 'arrival') {
                <soft-icon name="fa-regular fa-person-to-door" class="text-base" />
                {{ '#TIMESTAMP.TYPE.ARRIVAL' | translate }}
              } @else {
                <soft-icon name="fa-regular fa-house-person-leave" class="text-base" />
                {{ '#TIMESTAMP.TYPE.DEPARTURE' | translate }}
              }
            </soft-ds-badge>
          }
        </div>
        <div class="flex flex-col w-full mt-3">
          <label for="code" class="soft-label top">
            {{ '#TIMESTAMP.RECORD.CODE' | translate }}
          </label>
          <soft-ds-select
            id="code"
            [value]="form.get('code')?.value ?? null"
            (valueChange)="form.get('code')?.setValue($event)"
            [disabled]="codeDisabled()"
          >
            <soft-ds-select-option
              [value]="null"
              label="{{ '#TIMESTAMP.DEFAULT_CODE' | translate }}"
            />
            @for (code of codes.value() ?? []; track code) {
              <soft-ds-select-option
                [value]="code"
                [label]="
                  code.description ? code.name + ' - ' + code.description : code.name
                "
              />
            }
          </soft-ds-select>
        </div>
      </div>
      <div class="flex flex-col mt-3">
        <label for="timestamp" class="soft-label soft-label-top">
          {{ '#TIMESTAMP.RECORD.TIMESTAMP' | translate }}
        </label>
        @if (canModifyTime()) {
          <soft-date-time-input id="timestamp" formControlName="timestamp" />
        }
        @if ((canModifyTime()) === false) {
          <soft-date-time-input [readonly]="true" [value]="form.value.timestamp" />
        }
      </div>
      @let validation = validation$ | async;
      @if (validation?.messages?.length && validation?.messages?.[0]?.message) {
        <div class="mt-3 flex flex-col gap-1">
          <soft-validation-container [validation]="validation" />
        </div>
      }
      <div class="w-full pt-4">
        <soft-ds-button
          variant="primary"
          size="lg"
          class="w-full"
          (click)="onSubmit(form.value)"
        >
          <soft-icon name="fa-regular fa-stopwatch" />
          {{ '#TIMESTAMP.RECORD_TIMESTAMP' | translate }}
        </soft-ds-button>
      </div>
    </form>
  }
</div>
